
const generatePopulationData = (totalPopulation) => {
    const malePercentage = 0.65;
    // Calculate gender population
    const malePopulation = Math.round(totalPopulation * malePercentage);
    const femalePopulation = totalPopulation - malePopulation;

    // Define age group percentage splits (must total 100%)
    const ageGroupPercents = {
        age_18_29: 0.255,   // 25.5%
        age_30_39: 0.23,    // 23%
        age_40_49: 0.192,   // 19.2%
        age_50_59: 0.168,   // 16.8%
        age_60_above: 0.155 // 15.5%
    };

    // Dynamically calculate age group counts
    const ageGroups = {};
    let ageGroupTotal = 0;
    for (const [group, percent] of Object.entries(ageGroupPercents)) {
        const count = Math.floor(totalPopulation * percent);
        ageGroups[group] = count;
        ageGroupTotal += count;
    }

    // Adjust last group to make total match exactly (if any rounding mismatch)
    const diff = totalPopulation - ageGroupTotal;
    const lastGroup = Object.keys(ageGroups).pop();
    ageGroups[lastGroup] += diff;

    return {
        male_population: malePopulation || 233132,
        female_population: femalePopulation || 255970,
        age_groups: ageGroups || {
            "age_18_29": 119396,
            "age_30_39": 103770,
            "age_40_49": 97955,
            "age_50_59": 79622,
            "age_60_above": 88359
        }
    };
}

export const inflateDistData = (value, label) => {
    const data = generatePopulationData(value);
    const getDistObj = distWiseData()[label];
    getDistObj.total_population = value;
    // getDistObj.male_population = data?.male_population || 0;
    // getDistObj.female_population = data?.female_population || 0;
    getDistObj.age_groups = data?.age_groups;
    return getDistObj
}

export const inflateStateData = () => {
    return {
        "health_facility_count": 238,
        "village_count": 1437,
        "total_population": 489102,
        "male_population": 229879,
        "female_population": 259223,
        "age_groups": {
            "age_18_29": 119396,
            "age_30_39": 103770,
            "age_40_49": 97955,
            "age_50_59": 79622,
            "age_60_above": 88359
        },
        "age_groups": {
            "age_18_29": 119396,
            "age_30_39": 103770,
            "age_40_49": 97955,
            "age_50_59": 79622,
            "age_60_above": 88359
        },
        "dm_cases": {
            "known_male": 7001,
            "suspected_male": 7755,
            "referred_male": 17813,
            "known_female": 7868,
            "suspected_female": 11996,
            "referred_female": 0
        },
        "htn_cases": {
            "known_male": 11471,
            "suspected_male": 12079,
            "referred_male": 21716,
            "known_female": 12543,
            "suspected_female": 12063,
            "referred_female": 0
        },
        "oc_cases": {
            "known_male": 18,
            "suspected_male": 11,
            "referred_male": 0,
            "known_female": 29,
            "suspected_female": 13,
            "referred_female": 0
        },
        "bc_cases": {
            "known_male": 0,
            "suspected_male": 0,
            "referred_male": 0,
            "known_female": 82,
            "suspected_female": 15,
            "referred_female": 0
        },
        "cc_cases": {
            "known_male": 0,
            "suspected_male": 0,
            "referred_male": 0,
            "known_female": 48,
            "suspected_female": 6,
            "referred_female": 0
        },
        "cvd_cases": {
            "known_male": 406,
            "suspected_male": 108,
            "referred_male": 43,
            "known_female": 395,
            "suspected_female": 126,
            "referred_female": 39
        },
        "copd_cases": {
            "known_male": 213,
            "suspected_male": 143,
            "referred_male": 0,
            "known_female": 336,
            "suspected_female": 188,
            "referred_female": 0
        },
        "ckd_cases": {
            "known_male": 388,
            "suspected_male": 2391,
            "referred_male": 0,
            "known_female": 405,
            "suspected_female": 2281,
            "referred_female": 0
        },
        "dm_htn_cases": {
            "known_male": 1001,
            "suspected_male": 0,
            "referred_male": 0,
            "known_female": 1186,
            "suspected_female": 0,
            "referred_female": 0
        },
        "ps_cases": {
            "known_male": 892,
            "suspected_male": 0,
            "referred_male": 0,
            "known_female": 527,
            "suspected_female": 0,
            "referred_female": 0
        },
        "bmi_cases": {
            "known_male": 76520,
            "suspected_male": 0,
            "referred_male": 0,
            "known_female": 88209,
            "suspected_female": 0,
            "referred_female": 0
        },
        "mh_cases": {
            "known_male": 834,
            "suspected_male": 166,
            "referred_male": 0,
            "known_female": 764,
            "suspected_female": 242,
            "referred_female": 0
        }
    }
}

export const distWiseData = () => {
    return {
        'Chandel': {
            "health_facility_count": 9,
            "village_count": 102,
            "total_population": 8737,
            "male_population": 3829,
            "female_population": 4318,
            "age_groups": {
                "age_18_29": 2443,
                "age_30_39": 2061,
                "age_40_49": 1626,
                "age_50_59": 1178,
                "age_60_above": 1356
            },
            "dm_cases": {
                "known_male": 119,
                "suspected_male": 229,
                "referred_male": 61,
                "known_female": 177,
                "suspected_female": 329,
                "referred_female": 96
            },
            "htn_cases": {
                "known_male": 302,
                "suspected_male": 389,
                "referred_male": 115,
                "known_female": 326,
                "suspected_female": 420,
                "referred_female": 133
            },
            "oc_cases": {
                "known_male": 1,
                "suspected_male": 1,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 1,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 7,
                "suspected_male": 3,
                "referred_male": 1,
                "known_female": 11,
                "suspected_female": 2,
                "referred_female": 1
            },
            "copd_cases": {
                "known_male": 2,
                "suspected_male": 2,
                "referred_male": 0,
                "known_female": 8,
                "suspected_female": 2,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 9,
                "suspected_male": 53,
                "referred_male": 0,
                "known_female": 7,
                "suspected_female": 51,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 14,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 19,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 21,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 14,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 1786,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 2520,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 25,
                "suspected_male": 12,
                "referred_male": 0,
                "known_female": 10,
                "suspected_female": 15,
                "referred_female": 0
            }
        },
        'Bishnupur': {
            "health_facility_count": 40,
            "village_count": 95,
            "total_population": 7701,
            "male_population": 15105,
            "female_population": 17033,
            "age_groups": {
                "age_18_29": 1892,
                "age_30_39": 1649,
                "age_40_49": 1557,
                "age_50_59": 1161,
                "age_60_above": 1422
            },
            "dm_cases": {
                "known_male": 141,
                "suspected_male": 186,
                "referred_male": 78,
                "known_female": 164,
                "suspected_female": 324,
                "referred_female": 95
            },
            "htn_cases": {
                "known_male": 293,
                "suspected_male": 409,
                "referred_male": 128,
                "known_female": 278,
                "suspected_female": 399,
                "referred_female": 117
            },
            "oc_cases": {
                "known_male": 2,
                "suspected_male": 1,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 4,
                "suspected_female": 1,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 11,
                "suspected_male": 3,
                "referred_male": 2,
                "known_female": 12,
                "suspected_female": 1,
                "referred_female": 1
            },
            "copd_cases": {
                "known_male": 6,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 10,
                "suspected_female": 3,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 9,
                "suspected_male": 57,
                "referred_male": 0,
                "known_female": 12,
                "suspected_female": 49,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 18,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 30,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 19,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 8,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 2041,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 2255,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 26,
                "suspected_male": 1,
                "referred_male": 0,
                "known_female": 10,
                "suspected_female": 3,
                "referred_female": 0
            }
        },
        'Churachandpur': {
            "health_facility_count": 1,
            "village_count": 1,
            "total_population": 1,
            "male_population": 0,
            "female_population": 1,
            "age_groups": {
                "age_18_29": 1,
                "age_30_39": 0,
                "age_40_49": 0,
                "age_50_59": 0,
                "age_60_above": 0
            },
            "dm_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            }
        },
        'Imphal East': {
            "health_facility_count": 171,
            "village_count": 298,
            "total_population": 80314,
            "male_population": 56666,
            "female_population": 63899,
            "age_groups": {
                "age_18_29": 21270,
                "age_30_39": 17909,
                "age_40_49": 16146,
                "age_50_59": 11627,
                "age_60_above": 13254
            },
            "dm_cases": {
                "known_male": 1931,
                "suspected_male": 2150,
                "referred_male": 856,
                "known_female": 2101,
                "suspected_female": 3219,
                "referred_female": 1036
            },
            "htn_cases": {
                "known_male": 2306,
                "suspected_male": 2748,
                "referred_male": 770,
                "known_female": 2551,
                "suspected_female": 2726,
                "referred_female": 857
            },
            "oc_cases": {
                "known_male": 1,
                "suspected_male": 5,
                "referred_male": 0,
                "known_female": 9,
                "suspected_female": 3,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 20,
                "suspected_female": 6,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 20,
                "suspected_female": 5,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 101,
                "suspected_male": 38,
                "referred_male": 9,
                "known_female": 94,
                "suspected_female": 46,
                "referred_female": 13
            },
            "copd_cases": {
                "known_male": 70,
                "suspected_male": 25,
                "referred_male": 0,
                "known_female": 85,
                "suspected_female": 31,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 85,
                "suspected_male": 716,
                "referred_male": 0,
                "known_female": 87,
                "suspected_female": 675,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 211,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 246,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 211,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 124,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 21088,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 24659,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 295,
                "suspected_male": 11,
                "referred_male": 0,
                "known_female": 278,
                "suspected_female": 22,
                "referred_female": 0
            }
        },
        'Imphal West': {
            "health_facility_count": 187,
            "village_count": 407,
            "total_population": 71585,
            "male_population": 74322,
            "female_population": 83810,
            "age_groups": {
                "age_18_29": 17537,
                "age_30_39": 14716,
                "age_40_49": 14431,
                "age_50_59": 11026,
                "age_60_above": 13307
            },
            "dm_cases": {
                "known_male": 1696,
                "suspected_male": 2003,
                "referred_male": 731,
                "known_female": 1837,
                "suspected_female": 3074,
                "referred_female": 909
            },
            "htn_cases": {
                "known_male": 3259,
                "suspected_male": 3177,
                "referred_male": 1019,
                "known_female": 3584,
                "suspected_female": 3090,
                "referred_female": 1205
            },
            "oc_cases": {
                "known_male": 5,
                "suspected_male": 3,
                "referred_male": 0,
                "known_female": 8,
                "suspected_female": 4,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 21,
                "suspected_female": 2,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 11,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 105,
                "suspected_male": 19,
                "referred_male": 5,
                "known_female": 94,
                "suspected_female": 26,
                "referred_female": 6
            },
            "copd_cases": {
                "known_male": 52,
                "suspected_male": 34,
                "referred_male": 0,
                "known_female": 99,
                "suspected_female": 36,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 68,
                "suspected_male": 619,
                "referred_male": 0,
                "known_female": 79,
                "suspected_female": 597,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 337,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 350,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 232,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 129,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 18192,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 21123,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 135,
                "suspected_male": 44,
                "referred_male": 0,
                "known_female": 96,
                "suspected_female": 49,
                "referred_female": 0
            }
        },
        "Jiribam": {
            "health_facility_count": 8,
            "village_count": 3,
            "total_population": 839,
            "male_population": 384,
            "female_population": 434,
            "age_groups": {
                "age_18_29": 217,
                "age_30_39": 160,
                "age_40_49": 172,
                "age_50_59": 143,
                "age_60_above": 142
            },
            "dm_cases": {
                "known_male": 35,
                "suspected_male": 62,
                "referred_male": 9,
                "known_female": 26,
                "suspected_female": 63,
                "referred_female": 9
            },
            "htn_cases": {
                "known_male": 37,
                "suspected_male": 25,
                "referred_male": 17,
                "known_female": 52,
                "suspected_female": 37,
                "referred_female": 14
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 11,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 9,
                "suspected_female": 1,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 2,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 8,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 2,
                "suspected_male": 12,
                "referred_male": 0,
                "known_female": 2,
                "suspected_female": 12,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 2,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 3,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 4,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 2,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 242,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 277,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 2,
                "suspected_male": 1,
                "referred_male": 0,
                "known_female": 4,
                "suspected_female": 2,
                "referred_female": 0
            }
        },
        "Kakching": {
            "health_facility_count": 64,
            "village_count": 120,
            "total_population": 41311,
            "male_population": 20542,
            "female_population": 23165,
            "age_groups": {
                "age_18_29": 10465,
                "age_30_39": 8355,
                "age_40_49": 8176,
                "age_50_59": 6153,
                "age_60_above": 7818
            },
            "dm_cases": {
                "known_male": 573,
                "suspected_male": 604,
                "referred_male": 225,
                "known_female": 692,
                "suspected_female": 953,
                "referred_female": 340
            },
            "htn_cases": {
                "known_male": 1167,
                "suspected_male": 1107,
                "referred_male": 409,
                "known_female": 1261,
                "suspected_female": 1139,
                "referred_female": 439
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 3,
                "suspected_female": 1,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 8,
                "suspected_female": 1,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 3,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 27,
                "suspected_male": 10,
                "referred_male": 4,
                "known_female": 39,
                "suspected_female": 12,
                "referred_female": 3
            },
            "copd_cases": {
                "known_male": 22,
                "suspected_male": 16,
                "referred_male": 0,
                "known_female": 46,
                "suspected_female": 24,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 41,
                "suspected_male": 243,
                "referred_male": 0,
                "known_female": 34,
                "suspected_female": 223,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 170,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 216,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 161,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 100,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 6845,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 8317,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 52,
                "suspected_male": 12,
                "referred_male": 0,
                "known_female": 55,
                "suspected_female": 7,
                "referred_female": 0
            }
        },
        "Kamjong": {
            "health_facility_count": 3,
            "village_count": 8,
            "total_population": 0,
            "male_population": 133,
            "female_population": 149,
            "age_groups": {
                "age_18_29": 0,
                "age_30_39": 0,
                "age_40_49": 0,
                "age_50_59": 0,
                "age_60_above": 0
            },
            "dm_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            }
        },
        "Kangpokpi": {
            "health_facility_count": 7,
            "village_count": 13,
            "total_population": 3011,
            "male_population": 1203,
            "female_population": 1357,
            "age_groups": {
                "age_18_29": 919,
                "age_30_39": 749,
                "age_40_49": 546,
                "age_50_59": 370,
                "age_60_above": 416
            },
            "dm_cases": {
                "known_male": 47,
                "suspected_male": 57,
                "referred_male": 40,
                "known_female": 53,
                "suspected_female": 107,
                "referred_female": 43
            },
            "htn_cases": {
                "known_male": 88,
                "suspected_male": 136,
                "referred_male": 76,
                "known_female": 67,
                "suspected_female": 129,
                "referred_female": 57
            },
            "oc_cases": {
                "known_male": 1,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 2,
                "suspected_male": 2,
                "referred_male": 1,
                "known_female": 4,
                "suspected_female": 2,
                "referred_female": 1
            },
            "copd_cases": {
                "known_male": 2,
                "suspected_male": 2,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 2,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 1,
                "suspected_male": 22,
                "referred_male": 0,
                "known_female": 5,
                "suspected_female": 15,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 14,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 9,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 6,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 767,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 875,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 8,
                "suspected_male": 25,
                "referred_male": 0,
                "known_female": 9,
                "suspected_female": 47,
                "referred_female": 0
            }
        },
        "Noney": {
            "health_facility_count": 0,
            "village_count": 0,
            "total_population": 0,
            "male_population": 0,
            "female_population": 0,
            "age_groups": {
                "age_18_29": 0,
                "age_30_39": 0,
                "age_40_49": 0,
                "age_50_59": 0,
                "age_60_above": 0
            },
            "dm_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            }
        },
        "Pherzawl": {
            "health_facility_count": 0,
            "village_count": 5,
            "total_population": 0,
            "male_population": 260,
            "female_population": 292,
            "age_groups": {
                "age_18_29": 0,
                "age_30_39": 0,
                "age_40_49": 0,
                "age_50_59": 0,
                "age_60_above": 0
            },
            "dm_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            }
        },
        "Senapati": {
            "health_facility_count": 45,
            "village_count": 51,
            "total_population": 9705,
            "male_population": 3862,
            "female_population": 4356,
            "age_groups": {
                "age_18_29": 2523,
                "age_30_39": 2243,
                "age_40_49": 1842,
                "age_50_59": 1356,
                "age_60_above": 1732
            },
            "dm_cases": {
                "known_male": 208,
                "suspected_male": 263,
                "referred_male": 119,
                "known_female": 214,
                "suspected_female": 381,
                "referred_female": 124
            },
            "htn_cases": {
                "known_male": 366,
                "suspected_male": 512,
                "referred_male": 176,
                "known_female": 430,
                "suspected_female": 443,
                "referred_female": 212
            },
            "oc_cases": {
                "known_male": 2,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 2,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 14,
                "suspected_male": 3,
                "referred_male": 2,
                "known_female": 16,
                "suspected_female": 5,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 3,
                "suspected_male": 13,
                "referred_male": 0,
                "known_female": 8,
                "suspected_female": 10,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 13,
                "suspected_male": 53,
                "referred_male": 0,
                "known_female": 12,
                "suspected_female": 59,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 35,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 59,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 15,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 9,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 2208,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 2442,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 69,
                "suspected_male": 11,
                "referred_male": 0,
                "known_female": 68,
                "suspected_female": 20,
                "referred_female": 0
            }
        },
        "Tamenglong": {
            "health_facility_count": 4,
            "village_count": 19,
            "total_population": 105,
            "male_population": 695,
            "female_population": 783,
            "age_groups": {
                "age_18_29": 21,
                "age_30_39": 18,
                "age_40_49": 19,
                "age_50_59": 20,
                "age_60_above": 27
            },
            "dm_cases": {
                "known_male": 3,
                "suspected_male": 6,
                "referred_male": 3,
                "known_female": 6,
                "suspected_female": 8,
                "referred_female": 3
            },
            "htn_cases": {
                "known_male": 6,
                "suspected_male": 10,
                "referred_male": 4,
                "known_female": 11,
                "suspected_female": 13,
                "referred_female": 7
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 1,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 2,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 2,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 28,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 42,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 4,
                "suspected_female": 0,
                "referred_female": 0
            }
        },
        "Tengnoupal": {
            "health_facility_count": 24,
            "village_count": 43,
            "total_population": 1436,
            "male_population": 700,
            "female_population": 789,
            "age_groups": {
                "age_18_29": 339,
                "age_30_39": 307,
                "age_40_49": 269,
                "age_50_59": 238,
                "age_60_above": 282
            },
            "dm_cases": {
                "known_male": 25,
                "suspected_male": 170,
                "referred_male": 24,
                "known_female": 32,
                "suspected_female": 194,
                "referred_female": 29
            },
            "htn_cases": {
                "known_male": 23,
                "suspected_male": 192,
                "referred_male": 20,
                "known_female": 14,
                "suspected_female": 182,
                "referred_female": 13
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 4,
                "referred_male": 0,
                "known_female": 1,
                "suspected_female": 5,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 1,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 4,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 3,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 495,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 494,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            }
        },
        "Thoubal": {
            "health_facility_count": 175,
            "village_count": 232,
            "total_population": 82297,
            "male_population": 52178,
            "female_population": 58838,
            "age_groups": {
                "age_18_29": 22712,
                "age_30_39": 18042,
                "age_40_49": 16355,
                "age_50_59": 11547,
                "age_60_above": 13324
            },
            "dm_cases": {
                "known_male": 2209,
                "suspected_male": 2011,
                "referred_male": 1262,
                "known_female": 2561,
                "suspected_female": 3334,
                "referred_female": 1714
            },
            "htn_cases": {
                "known_male": 3607,
                "suspected_male": 3361,
                "referred_male": 1942,
                "known_female": 3961,
                "suspected_female": 3467,
                "referred_female": 2259
            },
            "oc_cases": {
                "known_male": 5,
                "suspected_male": 1,
                "referred_male": 0,
                "known_female": 6,
                "suspected_female": 5,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 26,
                "suspected_female": 4,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 12,
                "suspected_female": 1,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 127,
                "suspected_male": 29,
                "referred_male": 19,
                "known_female": 116,
                "suspected_female": 31,
                "referred_female": 14
            },
            "copd_cases": {
                "known_male": 51,
                "suspected_male": 48,
                "referred_male": 0,
                "known_female": 77,
                "suspected_female": 72,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 156,
                "suspected_male": 605,
                "referred_male": 0,
                "known_female": 165,
                "suspected_female": 592,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 198,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 245,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 216,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 140,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 22736,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 25103,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 215,
                "suspected_male": 49,
                "referred_male": 0,
                "known_female": 228,
                "suspected_female": 77,
                "referred_female": 0
            }
        },
        "Ukhrul": {
            "health_facility_count": 0,
            "village_count": 0,
            "total_population": 0,
            "male_population": 0,
            "female_population": 0,
            "age_groups": {
                "age_18_29": 0,
                "age_30_39": 0,
                "age_40_49": 0,
                "age_50_59": 0,
                "age_60_above": 0
            },
            "dm_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "oc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cc_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "cvd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "copd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ckd_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "dm_htn_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "ps_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "bmi_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            },
            "mh_cases": {
                "known_male": 0,
                "suspected_male": 0,
                "referred_male": 0,
                "known_female": 0,
                "suspected_female": 0,
                "referred_female": 0
            }
        }
    }
}